import { defineTapPropertyExtension, Tap } from '@iotize/tap';
import { TapNLinkUpdater } from '@iotize/tap/firmware-update';

declare module '@iotize/tap/lib/tap' {
  interface Tap {
    // firmwareUpdater(options?: TapNLinkUpdater.Options): TapNLinkUpdater;

    firmwareUpdater: TapFirmwareUpdateExtension;
  }
}

export const _TAP_EXTENSION_FIRMWARE_UPDATE_ = defineTapPropertyExtension(
  'firmwareUpdater',
  (context) => new TapFirmwareUpdateExtension(context),
);

/**
 * @deprecated use _TAP_EXTENSION_FIRMWARE_UPDATE_ instead
 */
export const __DEFINED_PROPERTY_GETTER_FIRMWARE_UPDATE_ =
  _TAP_EXTENSION_FIRMWARE_UPDATE_;

export class TapFirmwareUpdateExtension {
  constructor(private readonly context: { tap: Tap }) {}

  createLoader(packet: Uint8Array, options?: TapNLinkUpdater.Options) {
    return TapNLinkUpdater.create(this.context.tap, packet, options);
  }

  apply(packet: Uint8Array, options?: TapNLinkUpdater.Options) {
    return this.createLoader(packet, options).asObservable();
  }
}

// export function firmwareUpdater(
//     this: Tap,
//     options?: TapNLinkUpdater.Options
// ): TapNLinkUpdater {
//     return new TapNLinkUpdater(this, options);
// }

// Tap.prototype.firmwareUpdater = firmwareUpdater;
